'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { id } from '~/lib/@types/single-property-infinite-loop';
import { useHydrationSafeResponsive } from '~/lib/hooks/useResponsive';

type Props = PropsWithChildren;

const SinglePropertyInfiniteLoop: React.FC<Props> = ({ children }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const isDesktop = useHydrationSafeResponsive('desktop');

  useEffect(() => {
    setShouldRender(Boolean(isDesktop));
  }, [isDesktop]);

  if (shouldRender && typeof document !== 'undefined') {
    const container = document.getElementById(id);

    return container && <>{createPortal(children, container)}</>;
  }
};

export default SinglePropertyInfiniteLoop;
